import { StreakTutorialLayout } from '../../../Layouts/StreakBar/StreakTutorialLayout';
import { GameObjectEvent } from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import { Anim } from '../../../System/Animation/AnimationHelper';
import { IGameState } from '../../../State/Game/IGameState';
import { LevelComponent } from '../../../State/Level/LevelComponent';
import { FTUXStateHelper } from '../../../State/Game/FTUX/FTUXStateHelper';
import { FTUXType } from '../../../Player/PlayerProperty/Progress/FTUXType';
import RelativePositionComponent from '../../../Component/Render/RelativePosition';
import Point from '../../../Utility/Point';
import StreakBar from './StreakBar';
import { applyDefaultButtonAnimation } from '../../../System/UI/UIHelper';
import { LevelStatus } from 'State/Level/LevelStatus';
import { Layout } from '../../../Utility/layout/createLayout';

type StreakBarTutorialProps = {
    streakBar: StreakBar;
}

export default class StreakBarTutorial {
    private static shown: boolean = false;
    private readonly layout: any;
    private readonly streakBar: StreakBar;

    constructor(props: StreakBarTutorialProps) {
        this.streakBar = props.streakBar;

        this.layout = new StreakTutorialLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(1, 1);
        this.layout.playButton.on(GameObjectEvent.SELECTED, this.handlePlayClick);
        applyDefaultButtonAnimation(this.layout.playButton);

        StreakBarTutorial.shown = true;
        this.show();
    }

    public static shouldShow(state: IGameState): boolean {
        // Show once in 3rd level after 1st card match.
        // Can be shown in later level if for some reason player didn't see the tutorial uet
        return (
            state.levelState.levelNumber === 3 &&
            state.levelState.status === LevelStatus.ACTIVE &&
            state.levelState.components.includes(LevelComponent.BONUS_STREAK) &&
            !StreakBarTutorial.shown &&
            !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.BONUS_STREAK)
        );
    }

    public get root(): GameObject {
        return this.layout.root;
    }

    private readonly handlePlayClick = (): void => {
        this.hide();
    };

    private async show(): Promise<void> {
        this.layout.root.getComponent(Renderable).alpha = 0;
        this.streakBar.glow.getComponent(Renderable).visible = true;
        Anim(this.layout.root, { alpha: 1, duration: 500 });
        Anim(this.streakBar.glow, { alpha: 1, duration: 500 });
    }

    private async hide(): Promise<void> {
        Anim(this.streakBar.glow, { alpha: 0, duration: 500 });
        await Anim(this.layout.root, { alpha: 0, duration: 500 });
        this.layout.root.destroy();
        this.streakBar.glow.getComponent(Renderable).visible = false;
    }
}
